/* SA · Mejoras 30-oct (borrador)
   1) Los enlaces de WhatsApp de la tienda abren con un mensaje ya escrito (en la ficha, con el nombre del producto).
   2) En la ficha del producto: botón «¿Dudas? Pregúntanos por WhatsApp» bajo «Agregar al carrito»
      (reemplaza al de Messenger, que no funciona en celular). */
(function(){
  'use strict';
  if(window.__saMejoras30)return;window.__saMejoras30=true;
  var t=document.querySelector('[data-sa-tonito]');
  var TEL=String((t&&t.dataset.phone)||'50378091535').replace(/\D/g,'');
  var info=document.querySelector('.product__info-container');
  var h1=info&&info.querySelector('.product__title h1,.product__title h2');
  var producto=h1?h1.textContent.replace(/\s+/g,' ').trim():'';
  function texto(){return producto?'Hola, tengo una consulta sobre: '+producto+' '+location.origin+location.pathname:'Hola, quiero hacer un pedido en la Librería San Antonio';}
  function wa(){return 'https://wa.me/'+TEL+'?text='+encodeURIComponent(texto());}
  // 1) Mensaje ya escrito en los enlaces a nuestro WhatsApp que no traen uno
  [].forEach.call(document.querySelectorAll('a[href*="wa.me/"],a[href*="api.whatsapp.com/send"]'),function(a){
    var h=a.getAttribute('href')||'';if(/[?&]text=/.test(h))return;
    var n=(h.match(/wa\.me\/\+?(\d+)/)||h.match(/phone=\+?(\d+)/)||[])[1]||'';if(n.replace(/\D/g,'').slice(-8)!==TEL.slice(-8))return;
    a.setAttribute('href',wa());});
  // 2) Botón de dudas en la ficha
  if(info&&!info.querySelector('.sa-dudas-wa')){
    var botones=info.querySelector('.product-form__buttons')||info.querySelector('product-form');
    if(botones){var a=document.createElement('a');a.className='sa-dudas-wa';a.href=wa();a.target='_blank';a.rel='noopener';
      a.innerHTML='<svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true" fill="currentColor"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2Zm0 18.2a8.2 8.2 0 0 1-4.2-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2Zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8s-.4-.1-.6.1-.7.8-.8 1-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.3-.4.3-.4.7-1.3.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 3 3 0 0 0-.9 2.2 5.2 5.2 0 0 0 1.1 2.7 11.8 11.8 0 0 0 4.5 4c1.7.7 2.3.8 3.2.6a2.7 2.7 0 0 0 1.8-1.3 2.2 2.2 0 0 0 .1-1.3c0-.1-.2-.2-.5-.3Z"/></svg><span>¿Dudas? Pregúntanos por WhatsApp</span>';
      botones.insertAdjacentElement('afterend',a);}
  }
})();

/* 3) Menú de categorías del inicio (celular): flechas ‹ › para pasar, además del dedo */
(function(){
  document.querySelectorAll('.sa-categories-compact__grid').forEach(function(g){
    var box=g.parentElement;if(!box||box.querySelector('.sa-cat-flecha'))return;
    box.classList.add('sa-cat-con-flechas');
    function paso(){var c=g.querySelector('.sa-categories-compact__card');return c?(c.getBoundingClientRect().width+9)*2:220;}
    function mk(dir){var b=document.createElement('button');b.type='button';b.className='sa-cat-flecha sa-cat-flecha--'+(dir<0?'izq':'der');
      b.setAttribute('aria-label',dir<0?'Ver categorías anteriores':'Ver más categorías');b.innerHTML=dir<0?'&#8249;':'&#8250;';
      b.addEventListener('click',function(){g.scrollBy({left:dir*paso(),behavior:'smooth'});});box.appendChild(b);return b;}
    var izq=mk(-1),der=mk(1);
    function estado(){var max=g.scrollWidth-g.clientWidth-4;izq.hidden=g.scrollLeft<=4;der.hidden=g.scrollLeft>=max||max<=0;}
    g.addEventListener('scroll',estado,{passive:true});window.addEventListener('resize',estado);estado();setTimeout(estado,800);
  });
})();

/* 4) (31-oct) Buscador en celular (iPhone y Android):
      - Al bajar el teclado ya no se cierran las sugerencias: se cierran al tocar fuera del buscador, con la ✕ o al elegir una.
      - La lista de sugerencias se ajusta al espacio que deja libre el teclado (y la barra de abajo) y se puede deslizar,
        así siempre se ve lo que se escribe y todas las opciones. Usa el buscador del tema (predictive-search), no lo reemplaza. */
(function(){
  if(!window.customElements||window.__saBuscadorMovil)return;window.__saBuscadorMovil=true;
  var tactil=window.matchMedia('(hover: none), (pointer: coarse)');
  function ajustar(ps){
    var res=ps&&ps.predictiveSearchResults;if(!res||!ps.hasAttribute('open'))return;
    var vv=window.visualViewport,fondo=vv?vv.offsetTop+vv.height:window.innerHeight;
    var nav=document.querySelector('.sa-bottom-nav');
    if(nav&&getComputedStyle(nav).display!=='none'){var t=nav.getBoundingClientRect().top;if(t>0&&t<fondo)fondo=t;}
    var alto=Math.round(fondo-res.getBoundingClientRect().top-8);
    res.style.maxHeight=Math.max(150,alto)+'px';res.style.overflowY='auto';res.style.overscrollBehavior='contain';
  }
  function abiertos(){return document.querySelectorAll('predictive-search[open]');}
  customElements.whenDefined('predictive-search').then(function(){
    var P=customElements.get('predictive-search').prototype;
    var abrir=P.open,cerrar=P.close;
    P.open=function(){var r=abrir.apply(this,arguments);ajustar(this);return r;};
    P.close=function(limpiar){
      // En celular, bajar el teclado (blur) no cierra la lista; sí la cierran la ✕, Escape, tocar fuera o elegir.
      if(tactil.matches&&!limpiar&&!this.__saCerrar&&this.__saBlur&&Date.now()-this.__saBlur<600)return;
      this.__saCerrar=false;return cerrar.apply(this,arguments);
    };
    document.querySelectorAll('predictive-search').forEach(function(ps){
      ps.addEventListener('focusout',function(){ps.__saBlur=Date.now();},true);
    });
  });
  document.addEventListener('pointerdown',function(e){
    abiertos().forEach(function(ps){if(!ps.contains(e.target)){ps.__saCerrar=true;ps.close();}});
  },true);
  function reajustar(){abiertos().forEach(ajustar);}
  if(window.visualViewport){visualViewport.addEventListener('resize',reajustar);visualViewport.addEventListener('scroll',reajustar);}
  window.addEventListener('resize',reajustar);
  document.addEventListener('search:update',reajustar);
})();
